<div
  class="warning"
  *ngIf="isProd"
>
  PRODUCTION ENVIRONMENT
</div>

<div class="header">
  <div class="banner">
    <div class="left">
      <a
        class="logo"
        routerLink="/"
        merriNoFocusLink
      >
        <img
          [src]="logo"
          class="title-image"
        />Catalog</a
      >
    </div>
  </div>
</div>
